import axios from 'axios';
import { pipe, path } from 'ramda';
import {
  camelizeResponseHandler,
  decamelizeRequestHandler,
} from 'Api/api-mutations';
import ErrorHandler from 'Api/api-errors-handler';
import {
  ConfiguredCountryT,
  SelectedReturnServiceProviderT,
} from 'Api/models/ReturnServiceProvider';

const returnServiceProviderApi = axios.create({
  baseURL: '/api/carrier-products/merchants',
});

returnServiceProviderApi.interceptors.request.use((config) =>
  decamelizeRequestHandler(config, true)
);
returnServiceProviderApi.interceptors.response.use(
  pipe(camelizeResponseHandler, path(['data'])),
  ErrorHandler
);

export interface SelectedRspMatchT {
  selectedRspId: string;
  configuredCountry: ConfiguredCountryT;
}

export function fetchSelectedReturnServiceProviders(
  merchantId: string
): Promise<SelectedReturnServiceProviderT[]> {
  return returnServiceProviderApi
    .get(`/${merchantId}/selected-return-service-providers`)
    .then((res: any) => res.items ?? res) as Promise<
    SelectedReturnServiceProviderT[]
  >;
}

export function findConfiguredCountryForSalesChannel(
  providers: SelectedReturnServiceProviderT[],
  salesChannelId: string
): SelectedRspMatchT | null {
  for (const provider of providers) {
    const configuredCountry = provider.configuredCountries.find(
      (country) => country.salesChannelId === salesChannelId
    );
    if (configuredCountry) {
      return { selectedRspId: provider.id, configuredCountry };
    }
  }
  return null;
}

export function updateSelectedRspSalesChannel(
  merchantId: string,
  selectedRspId: string,
  salesChannelId: string,
  configuredCountry: ConfiguredCountryT
): Promise<void> {
  const {
    salesChannelId: _salesChannelId,
    countryCode: _countryCode,
    ...payload
  } = configuredCountry;

  return returnServiceProviderApi.put(
    `/${merchantId}/selected-return-service-providers/${selectedRspId}/sales-channels/${salesChannelId}`,
    payload
  ) as Promise<void>;
}
